export default [
    "admin",
    "affiliate",
    "lender"
]